<h2
  mat-dialog-title
  mat-dialog-draggable-title
  style="margin-bottom: 0px !important"
>
  <span>{{ "title.edit_field" | translate }}</span>
  <button type="button" class="close" aria-label="Close" mat-dialog-close>
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography">
  <section>
    <form [formGroup]="mainFormGroup">
      <div class="row pt-3 mt-3">
        <div class="col-4">
          <mat-form-field>
            <input
              matInput
              type="text"
              maxlength="200"
              formControlName="name"
              readonly
              placeholder="{{ 'signature_config.name' | translate }}"
            />
          </mat-form-field>
        </div>
        <div class="col-4">
          <mat-form-field>
            <mat-select
              required
              formControlName="object"
              [placeholder]="'signature_config.choose_subject' | translate"
            >
              <mat-option
                *ngFor="let object of listObject"
                [value]="object.code"
              >
                {{ object.name }}
              </mat-option>
            </mat-select>
            <button
              mat-button
              type="button"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              *ngIf="mainFormGroup?.controls?.object.value"
              (click)="mainFormGroup?.controls?.object.patchValue(null)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="!mainFormGroup.controls.object.value">
              {{ "signature_config.object_required" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div>
        <mat-table [dataSource]="data" formArrayName="prop">
          <!-- số thứ tự Column -->
          <ng-container matColumnDef="stt">
            <mat-header-cell
              *matHeaderCellDef
              class="mat-cell-non-boder-right-bottom"
              >{{ "headertable.stt" | translate }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element; let i = index"
              class="mat-cell-non-boder-right-bottom"
            >
              {{ i + 1 }}
            </mat-cell>
          </ng-container>

          <!-- Trang chứa chân ký Column -->
          <ng-container matColumnDef="page">
            <mat-header-cell
              *matHeaderCellDef
              class="mat-cell-non-boder-right-bottom"
              >{{ "headertable.page_signature" | translate }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element; let i = index"
              class="mat-cell-non-boder-right-bottom cell"
            >
              <span class="fix-width fw-100 nameDoc">{{ element?.page }}</span>
            </mat-cell>
          </ng-container>

          <!-- Thiết lập chân ký chính Column -->
          <ng-container matColumnDef="isMainSignature">
            <mat-header-cell
              *matHeaderCellDef
              class="mat-cell-non-boder-right-bottom"
              >{{ "headertable.mainSignature" | translate }}
            </mat-header-cell>
            <mat-cell
              class="mat-cell-non-boder-right-bottom"
              *matCellDef="let element; let i = index"
              [formGroupName]="i"
            >
              <mat-checkbox
                formControlName="main"
                color="primary"
                class="check_box"
                [(checked)]="this.checkboxList[i]"
                (change)="toggle($event, i)"
              ></mat-checkbox>
            </mat-cell>
          </ng-container>

          <!-- Độ rộng khung ký Column -->
          <ng-container matColumnDef="frameWidth">
            <mat-header-cell
              *matHeaderCellDef
              class="mat-cell-non-boder-right-bottom"
              >{{ "headertable.frameWidth" | translate }}
            </mat-header-cell>
            <mat-cell
              class="mat-cell-non-boder-right-bottom"
              *matCellDef="let element; let i = index"
              [formGroupName]="i"
            >
              <input
                matInput
                type="number"
                min="1"
                [pattern]="descriptPattern"
                (focusout)="this.focusOut(element, i)"
                autocomplete="off"
                formControlName="width"
                (keydown.enter)="$event.preventDefault()"
              />
            </mat-cell>
          </ng-container>

          <!-- Độ cao khung ký Column -->
          <ng-container matColumnDef="frameHeight">
            <mat-header-cell
              *matHeaderCellDef
              class="mat-cell-non-boder-right-bottom"
              >{{ "headertable.frameHeight" | translate }}
            </mat-header-cell>
            <mat-cell
              class="mat-cell-non-boder-right-bottom"
              *matCellDef="let element; let i = index"
              [formGroupName]="i"
            >
              <input
                matInput
                type="number"
                min="1"
                (focusout)="this.focusOut(element, i)"
                [pattern]="descriptPattern"
                autocomplete="off"
                formControlName="height"
                (keydown.enter)="$event.preventDefault()"
              />
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row
            *matRowDef="let row; columns: displayedColumns"
            class="element-row"
          >
          </mat-row>
        </mat-table>
      </div>
    </form>
  </section>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions style="float: right">
  <button mat-stroked-button color="primary" class="mr-3" (click)="cancel()">
    <mat-icon class="mr-0">cancel</mat-icon>{{ "form.cancel" | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="submitForm()">
    <mat-icon class="mr-0">save</mat-icon>
    <span>{{ "form.update" | translate }}</span>
  </button>
</mat-dialog-actions>
